/* ==========================================================================
   Sticky add-to-cart bar (custom — Valentina Massimo) · Wealth Kings-thema

   27-aug-2026: vormgeving herbouwd naar het Casa Provincial-model (foto,
   titel, prijsregel, ronde plus-knop) met de gekozen maat/kleur en "Cambiar"
   eronder. In dit bestand is alleen updateUI() uitgebreid met prijs- en
   uitverkocht-status; alle overige logica is bewust ONGEWIJZIGD gebleven.

   Uitgangspunten die BLIJVEN gelden:
   - Submit loopt via het bestaande productformulier (form-attribuut +
     name="add"), zodat cart-drawer.js / UpCart de add-to-cart afhandelen.
     Nooit zelf fetchen.
   - De bar houdt geen eigen variant-state bij: hij leest het verborgen
     id-veld van het formulier en zoekt die id op in de JSON uit de Liquid.
     Daardoor kan hij nooit uit de pas lopen met de hoofdkiezer.
   - Verschijnen/verdwijnen: zodra de hoofd-ATC uit beeld is (met 40px
     hysterese) en weer weg zodra de trustpoints/footer in beeld komen.
   ========================================================================== */
(function () {
  'use strict';

  var KIEZER_MARGE = 100; /* px tussen de bovenkant van het scherm en de kiezer */

  /* Vanaf welk blok onderaan de pagina de bar weer verdwijnt. 20-aug op
     verzoek van de trustpoints i.p.v. de footer; die staat er als vangnet
     achter voor sjablonen zonder trustpoints. */
  var STOP_SELECTORS = ['.trust-points', 'footer.footer'];

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var root = document.querySelector('[data-vm-sticky-atc]');
    if (!root || root.dataset.vmInit) return;
    root.dataset.vmInit = '1';

    var form = document.querySelector('form[data-product-form][action*="/cart/add"]') ||
               document.querySelector('form.product-info__form[action*="/cart/add"]') ||
               document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    /* Let op: form.id zou het input[name="id"]-element teruggeven (DOM-shadowing),
       dus altijd via get/setAttribute werken. */
    var formId = form.getAttribute('id');
    if (!formId) {
      formId = 'VMProductForm-' + Math.round(Math.random() * 1e6);
      form.setAttribute('id', formId);
    }

    var btn = root.querySelector('[data-vm-sticky-add]');
    var btnText = root.querySelector('[data-vm-sticky-add-text]');
    var imageEl = root.querySelector('[data-vm-sticky-image]');
    var optionsEl = root.querySelector('[data-vm-sticky-options]');
    var metaEl = root.querySelector('.vm-sticky-atc__meta');
    var changeBtn = root.querySelector('[data-vm-sticky-change]');
    var priceEl = root.querySelector('[data-vm-sticky-price]');
    var compareEl = root.querySelector('[data-vm-sticky-compare]');
    var soldoutEl = root.querySelector('[data-vm-sticky-soldout]');
    var idInput = form.querySelector('[data-variant-id-input]') || form.querySelector('input[name="id"]');

    if (!btn) return;
    btn.setAttribute('form', formId);

    var variants = {};
    try {
      var dataNode = root.querySelector('[data-vm-sticky-variants]');
      if (dataNode) variants = JSON.parse(dataNode.textContent || '{}');
    } catch (e) {}

    /* ---- Knop: klik expliciet afhandelen ---------------------------------
       Op iOS kon een tik verloren gaan door de combinatie form-attribuut +
       animatie-race. preventDefault + eigen requestSubmit is deterministisch,
       en dubbele tikken tijdens het toevoegen worden genegeerd. */
    btn.addEventListener('click', function (ev) {
      if (btn.disabled || btn.classList.contains('is-loading')) {
        ev.preventDefault();
        return;
      }
      var heeftRequestSubmit = typeof form.requestSubmit === 'function';
      var heeftSubmitEvent = typeof window.SubmitEvent === 'function';
      if (!heeftRequestSubmit && !heeftSubmitEvent) return; /* stokoude browser: native pad */
      ev.preventDefault();
      if (heeftRequestSubmit) {
        form.requestSubmit(btn);
      } else {
        form.dispatchEvent(new SubmitEvent('submit', { bubbles: true, cancelable: true, submitter: btn }));
      }
    });

    /* ---- Bar bijwerken vanuit het formulier ------------------------------ */
    function huidigeVariant() {
      var id = idInput ? String(idInput.value || '') : '';
      return variants[id] || null;
    }

    function updateUI() {
      var v = huidigeVariant();
      if (!v) return;

      var beschikbaar = v.a === true;
      var label = (v.t || '').replace(/\s*\/\s*/g, ' · ');

      if (optionsEl) optionsEl.textContent = label;
      /* De metaregel blijft ook staan als er geen variantnaam is maar het
         artikel wel uitverkocht is — anders verdwijnt die melding. */
      if (metaEl) metaEl.hidden = !label && beschikbaar;
      if (imageEl && v.img && imageEl.getAttribute('src') !== v.img) imageEl.src = v.img;

      if (priceEl && v.p) priceEl.textContent = v.p;
      if (compareEl) {
        if (v.c) {
          compareEl.textContent = v.c;
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (soldoutEl) soldoutEl.hidden = beschikbaar;

      btn.disabled = !beschikbaar;
      btn.setAttribute('aria-label', beschikbaar ? btn.dataset.defaultText : btn.dataset.soldoutText);
      if (btnText && !btn.classList.contains('is-loading')) {
        btnText.textContent = beschikbaar ? btn.dataset.defaultText : btn.dataset.soldoutText;
      }
    }

    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-option-button]')) {
        setTimeout(updateUI, 80);
      }
    }, true);

    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-variant-picker]')) {
        setTimeout(updateUI, 80);
      }
    }, true);

    window.addEventListener('popstate', function () { setTimeout(updateUI, 80); });
    updateUI();

    /* ---- "Cambiar": terug naar de maat-/kleurkiezer -----------------------
       De kiezer wordt bij elke klik opnieuw opgezocht (het thema kan hem
       hertekenen na een variantwissel).

       Waarom een correctieslag: tijdens het smooth scrollen laden er foto's
       boven de kiezer, waardoor de pagina verspringt en de kiezer 100+ px
       boven beeld eindigde. Na afloop meten we opnieuw en corrigeren we in
       één sprong als hij niet netjes staat. */
    function kiezerElement() {
      return document.querySelector('[data-variant-picker]') ||
             document.querySelector('.product-info__options') ||
             form.querySelector('[data-add-to-cart]');
    }

    function scrollNaar(doel, zacht) {
      var top = doel.getBoundingClientRect().top + window.pageYOffset - KIEZER_MARGE;
      window.scrollTo({ top: Math.max(0, top), behavior: zacht ? 'smooth' : 'auto' });
    }

    if (changeBtn) {
      changeBtn.addEventListener('click', function () {
        var doel = kiezerElement();
        if (!doel) return;

        var zacht = !window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        scrollNaar(doel, zacht);

        setTimeout(function () {
          var t = doel.getBoundingClientRect().top;
          if (t < KIEZER_MARGE - 40 || t > KIEZER_MARGE + 120) scrollNaar(doel, false);
        }, 600);
      });
    }

    /* ---- Zichtbaarheid: tonen zodra de hoofd-ATC uit beeld is ------------
       Met hysterese (dode zone van 40px) zodat de bar niet flikkert rond het
       omslagpunt — dat at op iOS tikken op ("soms doet de knop niks"). */
    var ticking = false;

    function stopElement() {
      for (var i = 0; i < STOP_SELECTORS.length; i++) {
        var el = document.querySelector(STOP_SELECTORS[i]);
        if (el) return el;
      }
      return null;
    }

    function updateVisibility() {
      ticking = false;
      var mainAtc = form.querySelector('[data-add-to-cart]');
      var zichtbaar = root.classList.contains('vm-sticky-atc--visible');
      var show = zichtbaar;

      if (mainAtc) {
        var r = mainAtc.getBoundingClientRect();
        if (r.top === 0 && r.bottom === 0 && r.height === 0) {
          show = window.scrollY > 600;
        } else if (zichtbaar) {
          if (r.bottom > 40) show = false;
        } else {
          if (r.bottom < -40) show = true;
        }
      } else {
        show = window.scrollY > 600;
      }

      /* Onderaan de pagina weer verbergen: zodra de trustpoints in beeld
         komen (of, ontbreken die, de footer), gaat de bar weg. */
      if (show) {
        var stop = stopElement();
        if (stop) {
          var sr = stop.getBoundingClientRect();
          var vh = window.innerHeight || document.documentElement.clientHeight;
          if (sr.top < vh - 10) show = false;
        }
      }

      root.classList.toggle('vm-sticky-atc--visible', show);
      root.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(updateVisibility); }
    }, { passive: true });

    window.addEventListener('resize', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(updateVisibility); }
    }, { passive: true });

    updateVisibility();

    /* ---- Laad-status op de knop ------------------------------------------ */
    form.addEventListener('submit', function (ev) {
      if (ev.submitter !== btn) return;
      btn.classList.add('is-loading');
      if (btnText) btnText.textContent = btn.dataset.addingText;
      setTimeout(function () {
        btn.classList.remove('is-loading');
        if (btnText && !btn.disabled) btnText.textContent = btn.dataset.defaultText;
      }, 2000);
    });
  });
})();
